import { uiSize } from '@utils'

interface Props {
  color?: string
  opacity?: string
}

function ArrowRightIcon({ color = 'var(--text-primary)', opacity = '0.8' }: Props) {
  return (
    <svg width={uiSize(13)} height={uiSize(9)} viewBox='0 0 13 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g opacity={opacity}>
        <path d='M0 4.45264L11.6442 4.45264' stroke={color} strokeWidth='1.2' />
        <path d='M9 1L12 4.5L9 8' stroke={color} strokeWidth='1.2' />
      </g>
    </svg>
  )
}

export default ArrowRightIcon
